import {
  differenceInHours,
  differenceInMinutes,
  format,
  parseISO,
  subHours
} from 'date-fns';

export const STANDARD_GERMANY_DATE = 'dd.MM.yyyy H:mm';
export const SHORT_STANDARD_GERMANY_DATE = 'dd.MM.yyyy';
export const FORMAT_GERMANY_TIME = 'hh:mm a';

export const SHORT_STANDARD_BACKEND_DATE = 'YYYY-MM-DD';

export const formatDate = (
  date,
  { shortFormat = false, formatPattern = STANDARD_GERMANY_DATE } = {}
) => {
  if (!date) return date;
  const formattedDate = typeof date === 'string' ? parseISO(date) : date;

  if (shortFormat) return format(formattedDate, SHORT_STANDARD_GERMANY_DATE);

  return `${format(formattedDate, formatPattern)} GMT`;
};

export const formatTime = (time) => {
  if (!time) return time;
  const formattedTime = typeof time === 'string' ? parseISO(time) : time;

  return format(formattedTime, FORMAT_GERMANY_TIME);
};

export const diffDates = (date, baseDate) => {
  const formattedDate = parseISO(date);
  let formattedBaseDate = parseISO(baseDate);

  let hours = differenceInHours(formattedBaseDate, formattedDate);
  if (hours > 0) {
    formattedBaseDate = subHours(formattedBaseDate, hours);
  } else {
    hours = 0;
  }
  let minutes = differenceInMinutes(formattedBaseDate, formattedDate);
  if (minutes < 0) {
    minutes = 0;
  }
  return { hours, minutes };
};

export const formatRangePickerDate = (
  date,
  formatPattern = SHORT_STANDARD_BACKEND_DATE
) => {
  if (!date) return undefined;

  if (date._isAMomentObject) {
    return date.format(formatPattern);
  }
  const formattedDate = typeof date === 'string' ? parseISO(date) : date;

  return format(formattedDate, formatPattern);
};
